import {merge} from "lodash";
import partnerMessages from "@i18n_messages_nl"

export default merge({}, partnerMessages);